/* Small progressive enhancements; Shopify remains responsible for cart and search. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-quantity]').forEach((wrapper) => {
      if (wrapper.dataset.initialized) return;
      wrapper.dataset.initialized = 'true';
      const input = wrapper.querySelector('input');
      wrapper.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
        input.stepDown(); input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      wrapper.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
        input.stepUp(); input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    root.querySelectorAll('[data-auto-submit]').forEach((select) => {
      if (select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      select.addEventListener('change', () => select.form.requestSubmit());
    });
    root.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const showMedia = (id) => {
        if (!id || !section.querySelector(`[data-media-id="${id}"]`)) return;
        section.querySelectorAll('[data-media-id]').forEach((media) => {
          const active = media.dataset.mediaId === String(id);
          media.classList.toggle('is-active', active);
          if (!active) media.querySelectorAll('video').forEach((video) => video.pause());
        });
        section.querySelectorAll('[data-thumbnail]').forEach((thumbnail) => {
          const active = thumbnail.dataset.thumbnail === String(id);
          thumbnail.classList.toggle('is-active', active);
          if (active) thumbnail.setAttribute('aria-current', 'true'); else thumbnail.removeAttribute('aria-current');
        });
      };
      section.querySelectorAll('[data-thumbnail]').forEach((thumbnail) => thumbnail.addEventListener('click', (event) => {
        event.preventDefault(); showMedia(thumbnail.dataset.thumbnail);
      }));
      const select = section.querySelector('[data-variant-select]');
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        section.querySelector('[data-variant-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-variant-compare]');
        compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;
        const availability = section.querySelector('[data-variant-availability]');
        availability.textContent = available ? 'Available' : 'Sold out';
        section.querySelector('[data-add-to-cart]').disabled = !available;
        section.querySelector('[data-add-label]').textContent = available ? 'Add to cart' : 'Sold out';
        section.querySelector('[data-variant-sku]').textContent = option.dataset.sku || '';
        section.querySelector('[data-sku-wrapper]').hidden = !option.dataset.sku;
        showMedia(option.dataset.media);
        const url = new URL(window.location.href); url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
        const liveRegion = document.getElementById('LiveRegion');
        if (liveRegion) liveRegion.textContent = `${option.textContent.trim()}. ${available ? 'Available' : 'Sold out'}.`;
      });
    });
    root.querySelectorAll('.rte table').forEach((table) => {
      if (table.parentElement.classList.contains('table-wrapper') || table.parentElement.classList.contains('bprl-table-wrap')) return;
      const wrapper = document.createElement('div'); wrapper.className = 'table-wrapper'; wrapper.tabIndex = 0;
      wrapper.setAttribute('role', 'region'); wrapper.setAttribute('aria-label', 'Scrollable data table');
      table.before(wrapper); wrapper.appendChild(table);
    });
    root.querySelectorAll('.filters-panel').forEach((panel) => {
      if (panel.dataset.initialized) return;
      panel.dataset.initialized = 'true';
      if (window.matchMedia('(max-width: 749px)').matches) panel.open = false;
    });
  };
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open]').forEach((details) => {
      details.open = false; details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nav-dropdown[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
})();
